// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2ACyy","inputWrap":"CustomTip_inputWrap__mU2GK"};